import useData from "./useData";
import { useCallback } from "react";
import bxApi from "../../utils/bxApi";
import useAuth from "../useAuth";

export interface StockCount {
    child: number | null,
    company: number,
    employee: number | null,
    employeename: string,
    exported: null,
    id: number | null,
    locked: null,
    name: string,
    profileid: number,
    received: Date,
    source: "Imported" | "Merged" | "Counted",
    status: "Counted" | "Merged" | "Deleted" | "Sent"
    user: number | null,
    userfullname: string | null,
    warehouse: string | null
}

const useStockCount = (pageOffset?: number, pageSize?: number, refetchInterval?: false | number) => {
    const { companyCode } = useAuth();
    const {
        data,
        ...others
    } = useData<StockCount>('/1.0/stockcounts', {
        pageOffset,
        pageSize: pageSize || 10000,
        refetchInterval,
        initFilters: [
            {
                id: 'activeonly',
                property: 'activeonly',
                value: true
            }
        ]
    });

    const importFromErp = useCallback(async () => {
        await bxApi.post(`/${companyCode}/1.0/stockcounts/import`);
    }, [companyCode]);

    const mergeLists = useCallback(async (name: string, lists: number[]) => {
        await bxApi.post(`/${companyCode}/1.0/stockcounts/merge`,
            {
                name,
                lists
            })
    }, [companyCode]);

    const sendListsToErp = useCallback(async (lists: number[]) => {
        await bxApi.post(`/${companyCode}/1.0/stockcounts/export`,
            {
                lists
            });
    }, [companyCode]);

    return {
        stockcounts: data,
        importFromErp,
        mergeLists,
        sendListsToErp,
        ...others
    }
}

export default useStockCount;